import dayjs from 'dayjs'
import filter from '@/rahmen/utils/filters'

export default {
  /*
    * 日付＆年月日を渡して経過時間（分）を取得する
    */
  calcDiffMinByYmdHms: function (fromYmd, fromHms, toYmd, toHms) {
    if (!(fromYmd) || !(fromHms) || !(toYmd) || !(toHms)) return ''
    if (fromYmd.length !== 10 || fromHms.length !== 5 || toYmd.length !== 10 || toHms.length !== 5) return ''

    var fromDate = fromYmd.replace(/\//g, '-') + 'T' + fromHms + ':00Z'
    var toDate = toYmd.replace(/\//g, '-') + 'T' + toHms + ':00Z'
    var dtFromDate = dayjs(fromDate)
    var dtToDate = dayjs(toDate)
    // diffの結果がミリ秒なので1000で除算し、その後分に変換
    return dtToDate.diff(dtFromDate, 'm')
  },
  /*
    * 時間から所要時間（分）を計算する
    */
  calcDiffMinByHms: function (fromHms, toHms) {
    if (!(fromHms) || !(toHms)) return ''
    if (fromHms.length !== 5 || toHms.length !== 5) return ''

    var fromMin = filter.timeToMinFormatter(fromHms)
    var toMin = filter.timeToMinFormatter(toHms)

    return fromMin - toMin
  }
}
